import type {
  MarketingProduct,
  ProductMarketingContent,
} from "@/product-marketing/types";

export const PRODUCT_MARKETING = {
  payroll: {
    name: "Payroll",
    title: "Payroll from the rules you already set",
    summary:
      "Hourly pay, commissions, and bonuses land in one workbook. Review the period, approve it, and send statements from here.",
    benefits: [
      {
        title: "Use your pay rules",
        description:
          "Bring hourly pay, commissions, and bonuses into one workbook.",
      },
      {
        title: "Review before you approve",
        description:
          "Check the calculations and resolve questions before you finish payroll.",
      },
      {
        title: "Help your team understand their pay",
        description:
          "Share detailed pay statements and manage pay questions in Volca.",
      },
      {
        title: "Keep each period organized",
        description:
          "Review each pay period in one place, from calculations to approved statements.",
      },
    ],
    previewTitle: "Weekly pay period",
    previewLabel: "Sample workbook",
    metrics: [
      { label: "Total pay", value: "$5,290" },
      { label: "Team members", value: "3" },
      { label: "Commission", value: "$1,450" },
    ],
    columns: ["Team member", "Hourly pay", "Commission", "Total pay"],
    rows: [
      ["Alex Morgan", "$1,200.00", "$450.00", "$1,650.00"],
      ["Jordan Lee", "$1,360.00", "$620.00", "$1,980.00"],
      ["Taylor Reed", "$1,280.00", "$380.00", "$1,660.00"],
    ],
    previewCalloutTitle: "Clear pay statements",
    previewNote: "Review the workbook, approve pay, and share statements.",
  },
  accounts_payable: {
    name: "Accounts Payable",
    title: "Invoices matched to the job",
    summary:
      "Match vendor invoices to purchase orders and jobs in ServiceTitan. Keep your pricebook costs current as vendor prices change.",
    benefits: [
      {
        title: "Reconcile invoices to POs and jobs",
        description:
          "Match invoice details to ServiceTitan purchase orders and jobs so costs reach the right place.",
      },
      {
        title: "Work with more vendors",
        description:
          "Process emailed or uploaded invoices, even from vendors without a ServiceTitan integration.",
      },
      {
        title: "Keep your pricebook current",
        description:
          "Update ServiceTitan pricebook costs from invoices, using your review and automation settings.",
      },
      {
        title: "Keep a record of cost changes",
        description:
          "Track pricebook cost changes with the source invoice and the values before and after each update.",
      },
    ],
    previewTitle: "Invoice reconciliation",
    previewLabel: "Matched to ServiceTitan purchase orders and jobs",
    metrics: [
      { label: "Invoices", value: "3" },
      { label: "Matched to jobs", value: "3" },
      { label: "Pricebook updates", value: "2" },
    ],
    columns: ["Vendor", "Invoice", "Purchase order", "Job"],
    rows: [
      ["Central Supply", "INV-1042", "PO-4021", "#12840"],
      ["Valley Parts", "INV-2081", "PO-4028", "#12856"],
      ["Metro Equipment", "INV-3064", "PO-4035", "#12872"],
    ],
    previewCalloutTitle: "Pricebook cost update",
    previewNote: "Valve assembly: $24.00 to $26.50. Source invoice: INV-1042.",
  },
} satisfies Record<MarketingProduct, ProductMarketingContent>;
